"use strict";
/* globals module */
/**
 * @module mediaGalleryInstanceFilesBatchRoute
 * @description Baasic Media Gallery Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var MediaGalleryInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryInstanceFilesBatchRoute, _super);
    function MediaGalleryInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'media-galleries/{mediaGalleryId}/files/batch/unlink';
        _this.updateRoute = 'media-galleries/{mediaGalleryId}/files/batch';
        _this.linkRoute = 'media-galleries/{mediaGalleryId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery file id of the original media gallery file used to identify media gallery files on which delete action should be performed.
     * @example mediaGalleryInstanceFilesBatchRoute.unlink(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.unlink = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery file need to be updated.
     * @example mediaGalleryInstanceFilesStreamsRoute.update(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.update = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be linked.
     * @example mediaGalleryInstanceFilesStreamsRoute.link(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.link = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    MediaGalleryInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGalleryInstanceFilesBatchRoute);
    return MediaGalleryInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.MediaGalleryInstanceFilesBatchRoute = MediaGalleryInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/
